import { render, staticRenderFns } from "./QRScanner.vue?vue&type=template&id=52097f97&scoped=true"
import script from "./QRScanner.vue?vue&type=script&lang=ts"
export * from "./QRScanner.vue?vue&type=script&lang=ts"
import style0 from "./QRScanner.vue?vue&type=style&index=0&id=52097f97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52097f97",
  null
  
)

export default component.exports